import { sectionEditService } from '../services'

export default (formId, datasource) => {
 	return new Promise((resolve, reject) => {
		sectionEditService.saveDS(formId, datasource)
 			.then(response => resolve(response.data))
			.catch(error => reject(error)
		);
 	})
}
